// extracted by mini-css-extract-plugin
export default {"itemContainer":"CartItem_itemContainer__OsU7b","imgContainer":"CartItem_imgContainer__jiiWs","title":"CartItem_title__W-Duq","control":"CartItem_control__3-pKC"};